import React, { useEffect, useState } from 'react';
import { getFirestore, collection, getDocs, setDoc, doc, deleteDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { app } from '../../firebase';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import swal from 'sweetalert';

const db = getFirestore(app);
const auth = getAuth(app);

function CampaignsComp() {
  const [campaigns, setCampaigns] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editCampaign, setEditCampaign] = useState(null);
  const [formData, setFormData] = useState({
    campaignName: '',
    platform: '',
    startDate: '',
    endDate: '',
    budget: '',
    status: 'Planned',
    notes: ''
  });

  const fetchCampaigns = async () => {
    const snapshot = await getDocs(collection(db, 'campaigns'));
    const data = snapshot.docs.map(doc => ({ ...doc.data(), docID: doc.id }));
    setCampaigns(data);
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const id = editCampaign ? editCampaign.docID : Date.now().toString();
    const payload = {
      ...formData,
      createdBy: auth.currentUser?.uid || 'unknown',
      docID: id
    };

    try {
      await setDoc(doc(db, 'campaigns', id), payload);
      swal('Success', `Campaign ${editCampaign ? 'updated' : 'added'} successfully`, 'success');
      setShowModal(false);
      fetchCampaigns();
      setFormData({
        campaignName: '',
        platform: '',
        startDate: '',
        endDate: '',
        budget: '',
        status: 'Planned',
        notes: ''
      });
      setEditCampaign(null);
    } catch (error) {
      swal('Error', error.message, 'error');
    }
  };

  const handleEdit = campaign => {
    setEditCampaign(campaign);
    setFormData(campaign);
    setShowModal(true);
  };

  const handleDelete = async id => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this campaign!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          await deleteDoc(doc(db, 'campaigns', id));
          swal('Deleted!', 'Campaign has been deleted.', 'success');
          fetchCampaigns();
        } catch (error) {
          swal('Error', error.message, 'error');
        }
      }
    });
  };

  return (
    <div className="teamsComponent">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Marketing Campaigns</h4>
        <Button onClick={() => { setShowModal(true); setEditCampaign(null); }}>
          + Add Campaign
        </Button>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Campaign</th>
            <th>Platform</th>
            <th>Start</th>
            <th>End</th>
            <th>Budget</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((c, index) => (
            <tr key={index}>
              <td>{c.campaignName}</td>
              <td>{c.platform}</td>
              <td>{c.startDate}</td>
              <td>{c.endDate}</td>
              <td>{c.budget}</td>
              <td>{c.status}</td>
              <td>
                <Button variant="warning" size="sm" onClick={() => handleEdit(c)}>Edit</Button>{' '}
                <Button variant="danger" size="sm" onClick={() => handleDelete(c.docID)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editCampaign ? 'Edit' : 'Add'} Campaign</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-2">
              <Form.Label>Campaign Name</Form.Label>
              <Form.Control type="text" name="campaignName" value={formData.campaignName} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Platform</Form.Label>
              <Form.Control type="text" name="platform" value={formData.platform} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Start Date</Form.Label>
              <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>End Date</Form.Label>
              <Form.Control type="date" name="endDate" value={formData.endDate} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Budget</Form.Label>
              <Form.Control type="number" name="budget" value={formData.budget} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Status</Form.Label>
              <Form.Select name="status" value={formData.status} onChange={handleChange} required>
                <option value="Planned">Planned</option>
                <option value="Running">Running</option>
                <option value="Completed">Completed</option>
                <option value="Paused">Paused</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Notes</Form.Label>
              <Form.Control as="textarea" name="notes" rows={3} value={formData.notes} onChange={handleChange} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
            <Button variant="primary" type="submit">
              {editCampaign ? 'Update' : 'Add'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default CampaignsComp;